import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import PropTypes from 'prop-types';
import styled from 'styled-components';
import Config from '../../config';
var Grid = styled.div.withConfig({
  displayName: "Grid",
  componentId: "sc-w8wlc5-0"
})(["box-sizing:border-box;margin-right:auto;margin-left:auto;max-width:100%;padding:", "rem;", ";", ";", ";", ";"], Config.grid.outerMargin, Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", "rem;\n  "])), Config.grid.outerMargin / 2), function (p) {
  return p.fluid && "padding: 0;\n  ";
}, function (p) {
  return !p.fluid && Config.media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["width: ", "rem;"])), Config.grid.container.lg);
}, function (p) {
  return !p.fluid && Config.media.xl(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["width: ", "rem;"])), Config.grid.container.xl);
});
Grid.defaultProps = {
  fluid: false
};
Grid.propTypes = {
  className: PropTypes.node,
  fluid: PropTypes.bool
};
export default Grid;